const IFRAME_ID = 'help-storage-iframe';
const IFRAME_NAME = 'help-storage-iframe';
const IFRAME_TITLE = 'Help Storage Hidden Iframe';
const STORAGE_ACTION_CLEAR = 'clear';
const STORAGE_ACTION_GET = 'get';
const STORAGE_ACTION_REMOVE = 'remove';
const STORAGE_ACTION_SET = 'set';
const STORAGE_ACTION_CHANGE = 'change';
const STORAGE_FROM_CLIENT = 'help-storage-client';
const STORAGE_FROM_SERVER = 'help-storage-server';
const STORAGE_TYPE_LOCAL = 'local';
// const STORAGE_TYPE_SESSION = 'session';

const getIframeSrcFromEnv = (env) => {
  let envPrefix = 'dev-';
  let subdomain = 'origin-help';
  if (env === 'test') {
    envPrefix = 'test-';
  }
  else if (env === 'prod' || env === 'production') {
    envPrefix = '';
    subdomain = 'gui';
  }
  return `https://${subdomain}.${envPrefix}godaddy.com/dc-apis/sidekick/help-storage/index.html`;
};

/* eslint-disable no-bitwise */
const generateUUID = () => (
  'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
    const r = Math.random() * 16 | 0;
    const v = c === 'x' ? r : (r & 0x3 | 0x8);
    return v.toString(16);
  })
);
/* eslint-enable no-bitwise */

const initialize = ({ env }) => new Promise(resolve => {
  if (
    typeof window !== 'undefined' &&
    window &&
    window.document
  ) {
    const iframeExisting = window.document.getElementById(IFRAME_ID);
    if (iframeExisting) {
      resolve();
      return;
    }

    const iframe = window.document.createElement('iframe');
    iframe.onload = resolve;

    iframe.id = IFRAME_ID;
    iframe.name = IFRAME_NAME;
    iframe.src = getIframeSrcFromEnv(env);
    iframe.title = IFRAME_TITLE;

    iframe.height = 0;
    iframe.width = 0;
    iframe.style = 'display: none;';
    iframe.tabIndex = '-1';

    window.document.body.appendChild(iframe);
  }
});

const setStorageEventHandler = (eventHandler) => {
  const iframe = window.document.getElementById(IFRAME_ID);
  if (!iframe) return;

  const iframeContentWindow = iframe.contentWindow;
  if (!iframeContentWindow) return;

  const eventListenerResponder = event => {
    if (event.data.from !== STORAGE_FROM_SERVER) return;
    if (event.data.action !== STORAGE_ACTION_CHANGE) return;

    const { key, newValue, oldValue, timeStamp } = event.data;
    eventHandler({ key, newValue, oldValue, timeStamp });
  };

  window.removeEventListener('message', eventListenerResponder);
  window.addEventListener('message', eventListenerResponder);
};

const checkIframeAndPostMessage = ({ action, keyName, keyValue, type }) => new Promise((resolve) => {
  if (
    typeof window !== 'undefined' &&
    window &&
    window.document
  ) {
    const iframe = window.document.getElementById(IFRAME_ID);
    if (!iframe) return;

    const iframeContentWindow = iframe.contentWindow;
    if (!iframeContentWindow) {
      console.error('Help storage iframe contentWindow not defined...'); // eslint-disable-line no-console
      return;
    }

    const messageId = generateUUID();

    const eventListenerResponder = (event) => {
      if (event.data.from !== STORAGE_FROM_SERVER) return;
      if (event.data.id !== messageId) return;

      if (event.data.action === STORAGE_ACTION_GET) {
        const getResult = event.data.value;
        resolve(getResult);
      } else {
        resolve(`Action complete: ${event.data.action}`);
      }

      window.removeEventListener('message', eventListenerResponder);
    };
    window.addEventListener('message', eventListenerResponder);

    iframeContentWindow.postMessage({
      action,
      id: messageId,
      from: STORAGE_FROM_CLIENT,
      keyName,
      keyValue,
      type,
    }, '*');
  }
});

const clear = (type = STORAGE_TYPE_LOCAL) => {
  return checkIframeAndPostMessage({ action: STORAGE_ACTION_CLEAR, type });
};

const getItem = (keyName, type = STORAGE_TYPE_LOCAL) => {
  return checkIframeAndPostMessage({ action: STORAGE_ACTION_GET, keyName, type });
};

const removeItem = (keyName, type = STORAGE_TYPE_LOCAL) => {
  return checkIframeAndPostMessage({ action: STORAGE_ACTION_REMOVE, keyName, type });
};

const setItem = (keyName, keyValue, type = STORAGE_TYPE_LOCAL) => {
  return checkIframeAndPostMessage({ action: STORAGE_ACTION_SET, keyName, keyValue, type });
};

module.exports = {
  clear,
  getItem,
  IFRAME_ID,
  initialize,
  removeItem,
  setItem,
  setStorageEventHandler,
};
